module.exports = __webpack_public_path__ + "img/IsFragile.17552e52.svg";